import { __decorate } from "tslib";
import { message } from 'ant-design-vue';
import { LogRequestStatus } from "../../LogTable/common";
import { Component, Vue, Inject, Watch, Prop } from "../../../vue";
import { map, sortBy, throttle } from "lodash-es";
import { logHandler } from '..';
import config from "../../LogTable/SeqDrawer/reportTypes/wujiDs";
import styles from "./WConsoleModal.module.css";
import HelperTooltip from "../../HelperTooltip";
import JsonTree from "../../LogTable/SeqDrawer/JsonTree";
import copyToClipboard from "../../../tools/clipboard";
const DS_LOG_LINK = '/xy/project/config/dslog';
const DS_CONFIG_LINK = '/xy/project/config/collection/list';
let DsLogList = class DsLogList extends Vue {
  constructor() {
    super(...arguments);
    this.logData = [];
    this.logFlow = {
      status: LogRequestStatus.NOT_LOADED_YET
    };
    this.searchValue = '';
    this.logDataAfterFilter = null;
  }
  get documentBody() {
    var _this$devToolDoc;
    return ((_this$devToolDoc = this.devToolDoc) === null || _this$devToolDoc === void 0 ? void 0 : _this$devToolDoc.body) || document.body;
  }
  get throttleFilterLogData() {
    return throttle(this.filterLogData, 100, {
      trailing: true
    });
  }
  onSearchValueChanged() {
    this.throttleFilterLogData();
  }
  async changeActiveKey(key) {
    if (key) this.logFlow = await logHandler.getLogDetail(key, this.projectId);
  }
  async created() {
    this.logData = await this.getLogData();
  }
  copy(value) {
    copyToClipboard(typeof value === 'string' ? value : JSON.stringify(value, undefined, 2), this.devToolDoc || document);
    message.success('已复制');
  }
  render() {
    const h = arguments[0];
    return h("a-collapse", {
      "on": {
        "change": this.changeActiveKey
      },
      "attrs": {
        "accordion": true,
        "bordered": false
      },
      "class": styles.logList
    }, [h("a-input-search", {
      "attrs": {
        "placeholder": "输入数据源名称或方法名称，支持多个关键字同时搜索(空格隔开)"
      },
      "on": {
        "search": this.filterLogData
      },
      "class": `${styles.searchInput} ${styles.importantClass}`,
      "model": {
        value: this.searchValue,
        callback: $$v => {
          this.searchValue = $$v;
        }
      }
    }), (this.logDataAfterFilter || this.logData).map(log => h("a-collapse-panel", {
      "key": log.seqId,
      "attrs": {
        "disabled": log.isExpired
      },
      "class": styles.collapsePanel
    }, [h("div", {
      "slot": "header"
    }, [h("div", {
      "class": styles.collapseHeader
    }, [log.isExpired && h("div", [h("a-icon", {
      "attrs": {
        "type": "delete"
      }
    }), "\u5DF2\u8FC7\u671F"])]), h("a-row", {
      "attrs": {
        "type": "flex"
      }
    }, [log.collectionId && log.cgiId ? h("a-col", {
      "attrs": {
        "flex": "auto"
      }
    }, [h("a-tooltip", {
      "attrs": {
        "title": "点击跳转至数据源配置页（自动跳转可能会被浏览器拦截）",
        "getPopupContainer": () => this.documentBody
      }
    }, [h("a", {
      "on": {
        "click": e => {
          e.stopPropagation();
          this.openLink(`${DS_CONFIG_LINK}?projectid=${log.projectId}&editingid=${log.collectionName}`);
        }
      }
    }, ["\u6570\u636E\u6E90\uFF1A", log.collectionName, "(", log.collectionId, ")"])]), h("a-divider", {
      "attrs": {
        "type": "vertical"
      }
    }), h("span", ["\u63A5\u53E3\uFF1A", log.cgiName, "(", log.cgiId, ")"])]) : h("a-col", {
      "attrs": {
        "flex": "auto"
      }
    }, [h("span", ["\u8BC6\u522B\u6570\u636E\u6E90\u4FE1\u606F\u5931\u8D25"])]), h("a-col", {
      "attrs": {
        "span": "6"
      }
    }, [h("a-tooltip", {
      "attrs": {
        "title": "请点击查看远程日志（自动跳转可能会被浏览器拦截）",
        "getPopupContainer": () => this.documentBody
      }
    }, [h("a", {
      "on": {
        "click": e => {
          e.stopPropagation();
          this.openLink(`${DS_LOG_LINK}?projectid=${log.projectId}&logfilter=${encodeURIComponent(`{"seq":{"logic":"=","value":"${log.seqId}"}}`)}`);
        }
      }
    }, ["\u94FE\u8DEFID\uFF1A", log.seqId])])])]), h("div", {
      "class": styles.collapseDetail
    }, [h("span", ["\u8BF7\u6C42\u8DEF\u5F84\uFF1A"]), h("span", [log.originalUrl])]), h("div", {
      "class": styles.collapseDetail
    }, [h("span", ["\u8BF7\u6C42\u65F6\u95F4\uFF1A"]), h("span", [`${new Date(log.timestamp).toLocaleString('zh', {
      hour12: false
    })}`])])]), h("a-card", [this.renderLogFlow()])]))]);
  }
  renderLogFlow() {
    const h = this.$createElement;
    if (this.logFlow.status === LogRequestStatus.NOT_LOADED_YET) return '';
    if (this.logFlow.status === LogRequestStatus.SUCCESS) {
      try {
        const sortedData = sortBy(map(this.logFlow.data, ele => JSON.parse(ele)), 'seqIndex'); // escape ts type check
        return h("div", [h("div", {
          "class": styles.request
        }, [`执行${config.Dimens.Dimen2Map[sortedData[0].dimen2]}模块的${config.Dimens.Dimen3Map[sortedData[0].dimen3]}。`, h("a-tooltip", {
          "attrs": {
            "title": "复制日志文本",
            "getPopupContainer": () => this.documentBody
          }
        }, [h("a-button", {
          "class": styles.copy,
          "attrs": {
            "icon": "copy",
            "size": "small",
            "type": "link"
          },
          "on": {
            "click": () => this.copy(sortedData)
          }
        })])]), h("a-timeline", [sortedData.map(step => h("a-timeline-item", [this.renderLogToolTip(step), h(JsonTree, {
          "attrs": {
            "jsonData": step.msg
          }
        })]))])]);
      } catch (e) {
        return h("span", {
          "class": styles.expiredAlert
        }, [h("a-icon", {
          "attrs": {
            "type": "alert"
          },
          "style": "margin-right: 5px;"
        }), "\u65E5\u5FD7\u6D41\u89E3\u6790\u5931\u8D25"]);
      }
    }
    if (this.logFlow.status === LogRequestStatus.KEY_ENOENT) {
      return h("span", {
        "class": styles.expiredAlert
      }, [h("a-icon", {
        "attrs": {
          "type": "delete"
        },
        "style": "margin-right: 5px;"
      }), "\u8BE5\u6761\u65E5\u5FD7\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u6253\u5F00", h("span", {
        "class": styles.wconsoleSpan
      }, ["Devtool"]), "\u5237\u65B0\u65E5\u5FD7\u5217\u8868\u3002"]);
    }
    if (this.logFlow.status === LogRequestStatus.REDIS_ENOENT) return h("span", {
      "class": styles.expiredAlert
    }, [h("a-icon", {
      "attrs": {
        "type": "disconnect"
      },
      "style": "margin-right: 5px;"
    }), "\u672A\u914D\u7F6ERedis\uFF0C\u5373\u65F6\u8C03\u8BD5\u65E5\u5FD7\u672A\u50A8\u5B58\u3002"]);
  }
  renderLogToolTip(step) {
    const h = this.$createElement;
    const briefInfo = config.Dimens.briefDimen45Info[`${step.dimen4}_${step.dimen5}`];
    let extraInfo = config.Dimens.Dimen45Map[`${step.dimen4}_${step.dimen5}`];
    const originDimenStr = step.dimen4 || step.dimen5 ? `自定义日志：${[step.dimen4, step.dimen5].filter(s => !!s).join(' -> ')}` : '未定义，请修改上报代码： attaLogger.log({ extraDimensions: ["tag1", "tag2"] })';
    if (!briefInfo) {
      extraInfo = config.Dimens.Dimen45Map.customDescription;
    }
    return h("span", {
      "class": styles.logTitle
    }, [h("span", {
      "style": {
        marginRight: '6px'
      }
    }, [briefInfo || originDimenStr]), h(HelperTooltip, {
      "attrs": {
        "title": extraInfo,
        "iconType": "question-circle"
      }
    }), h("a-tooltip", {
      "attrs": {
        "title": "复制日志文本",
        "getPopupContainer": () => this.documentBody
      }
    }, [h("a-button", {
      "class": styles.copy,
      "attrs": {
        "icon": "copy",
        "size": "small",
        "type": "link"
      },
      "on": {
        "click": () => this.copy(step.msg)
      }
    })])]);
  }
  async getLogData() {
    const logData = logHandler.logList();
    return logData;
  }
  filterLogData() {
    if (this.searchValue) {
      const searchValueArr = this.searchValue.split(' '); // 支持空格输入多个关键字
      if (searchValueArr.length !== 1) {
        this.logDataAfterFilter = this.logData.filter(logDetail => {
          const source = getSourceFromLogDetail(logDetail);
          return searchValueArr.every(searchKey => source.includes(searchKey));
        });
      } else {
        this.logDataAfterFilter = this.logData.filter(logDetail => {
          const source = getSourceFromLogDetail(logDetail);
          return source.includes(this.searchValue);
        });
      }
    } else {
      this.logDataAfterFilter = null;
    }
    function getSourceFromLogDetail(logDetail) {
      return [logDetail.collectionId, logDetail.cgiId, logDetail.collectionName, logDetail.cgiName].join(',');
    }
  }
  openLink(url) {
    // 在 DevTool 内点击可能会被浏览器拦截，等 DevTool 那边解决同源问题后再试试
    window.open(url);
  }
};
__decorate([Inject('devToolDoc')], DsLogList.prototype, "devToolDoc", void 0);
__decorate([Prop()], DsLogList.prototype, "projectId", void 0);
__decorate([Watch('searchValue')], DsLogList.prototype, "onSearchValueChanged", null);
DsLogList = __decorate([Component({
  name: 'DsLogList'
})], DsLogList);
export default DsLogList;
//# sourceMappingURL=DsLogList.js.map
